import React from 'react';

const num = (v) => {
  const n = parseFloat(String(v).replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n : 0;
};
const r2 = (n) => (n ? String(Math.round(n * 100) / 100) : '');
const ratio = (stake, potential) => (num(stake) && num(potential) ? r2(num(potential) / num(stake)) : '');

// Stake + potential are typed (or read from the slip); the multiplier is always derived (slips include bonus)
export const AmountsEditor = ({ value, onChange, testid = 'amounts' }) => {
  const set = (field, raw) => {
    const v = { ...value, [field]: raw };
    if (field === 'potential') v.auto = false;
    if (field === 'stake' && v.odds && v.auto) v.potential = r2(num(raw) * v.odds);
    onChange({ ...v, multiplier: ratio(v.stake, v.potential) });
  };
  const Field = ({ field, label, suffix, readOnly }) => (
    <label className="flex-1 min-w-0">
      <span className="block text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-1">{label}</span>
      <div className={`flex items-center border border-white/10 rounded-xl px-2.5 ${readOnly ? 'bg-[#1A1A1A]' : 'bg-[#111] focus-within:border-[#F5A623]/60'}`}>
        <input
          inputMode="decimal"
          value={value[field] ?? ''}
          readOnly={readOnly}
          tabIndex={readOnly ? -1 : undefined}
          placeholder={readOnly ? '—' : ''}
          onChange={readOnly ? undefined : (e) => set(field, e.target.value)}
          className={`w-full bg-transparent py-2 font-bold text-sm outline-none ${readOnly ? 'text-[#F5A623]' : 'text-white'}`}
          data-testid={`${testid}-${field}`}
        />
        {suffix && <span className="text-gray-500 text-xs">{suffix}</span>}
      </div>
    </label>
  );
  return (
    <div className="flex gap-2">
      {Field({ field: 'stake', label: 'Importo' })}
      {Field({ field: 'multiplier', label: 'Moltiplicatore', suffix: 'x', readOnly: true })}
      {Field({ field: 'potential', label: 'Potenziale' })}
    </div>
  );
};

// odds (AI Multipla): potential follows stake × total odds until the user types it
export const amountsFrom = (stake, potential, odds) => ({
  stake: r2(num(stake)), potential: r2(num(potential)), multiplier: ratio(stake, potential),
  ...(num(odds) ? { odds: num(odds), auto: true } : {}),
});

// legs changed in the editor: total odds = product of the remaining AI legs
export const withOdds = (a, odds) => ({
  ...a, odds, ...(a.auto && odds && num(a.stake) ? { potential: r2(num(a.stake) * odds), multiplier: r2(odds) } : {}),
});

export const amountsPayload = (v) => ({ stake: num(v.stake), potential: num(v.potential) });

export default AmountsEditor;
